export default "__VITE_ASSET__831eca30__"